import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import EffectUtility from "../../utilities/EffectUtility";
import EstimateModel from "./models/EstimateModel";
import EstimatePrintabelModel from "./models/EstimatePrintabelModel";

export interface IEstimateRequest {
    idRequestType?: number;
    idSimulation?: number;
    idEstimate?: number;
    idEstimateRequest?: number;
    IdFiliale?: number;
    fgTaxCodeForce?: boolean;
    customerPersonalInfo?: {
        name?: string;
        surname?: string;
        sex?: string;
        birthNation?: string;
        birthPlace?: string;
        birthForeignPlace?: string;
        birthCounty?: string;
        birthDate?: string;
        taxCode?: string;
        residenceNation?: string;
        residencePlace?: string;
        residencePlaceAboard?: string;
        residenceCounty?: string;
        residenceAddress?: string;
        residenceCivicNumber?: string;
        mobileNumber?: string;
        email?: string;
        residenceAddressType: string;
        idCertificazioneEmail?: Number | undefined;
    };
    customerWorkInfo?: {
        hiringDate?: string;
        idAdministration?: number;
        idAdministrativeCategory?: number;
        isAdminNotRegistered?: boolean;
        unregisteredAtcName?: string;
        hasAtcExceptions?: boolean;
    };
    idAgent?: number;
    sourceType?: number;
    sourceDetail?: string;
    existingCommitments?: {
        thirdPartiesYearExtinctions?: boolean;
        existingExtinctions?: number;
        existingAssignment?: boolean;
    };
    idAnag?: number;
    typeId?: number;
    idPracticeType?: number;
}

export default class EstimateEffect {
    public static async estimate(request: IEstimateRequest): Promise<EstimateModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.estimate;
        return EffectUtility.postToModel<EstimateModel>(EstimateModel, endpoint, request);
    }

    public static async estimatePrintable(
        id?: number,
        idEstimateRequest?: number
    ): Promise<EstimatePrintabelModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.printEstimate;
        return EffectUtility.getToModel<EstimatePrintabelModel>(EstimatePrintabelModel, endpoint, {
            idEstimate: id,
            idEstimateRequest: idEstimateRequest,
        });
    }
}
